<template>
  <div class="col-12"><br>
    <div class="card">
        <div class="card-header">
            <h3 id='ffff'>
                تقرير الاحصائيات الاسبوعي للمعلمين 
                <u id="fromto"></u>
            </h3>

                <b-dropdown
                id="dropdown-1"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                text="📥 طباعة / تصدير"
                variant="primary"
                >
                <b-dropdown-item @click="printDiv()">
                    <i class="fa fa-print"></i>
                    طباعة التقرير
                </b-dropdown-item><hr>
                <b-dropdown-item @click="exportToExcel()">
                    <i class="fa fa-download"></i>
                    تصدير التقرير اكسل
                </b-dropdown-item>
                </b-dropdown>
        </div>
        <div class="card-body" id="headerTable">
                <header  class='dnone'>
                    <div style='width: 100%; padding: 20px;'>
                        <div style='width: 30%; text-align: center; display: inline-block; position: relative;top:-20px !important'>
                            <h4>
                                <img src="https://cdn-static.brmja.com/storage/scrapped/6319866ea8712498504411.jpg"
                                    style='width: 40%' alt="">
                                <br>
                                وزارة التعليم
                                <br>
                                <div id="school_name">{{school_name}}</div>
                                </h4>
                        </div>
                        <div style='width: 30%; text-align: center; display: inline-block; position: relative; top: 5px'>
                            <br><br><br><br>
                            <img src='https://cdn-static.brmja.com/storage/scrapped/62793ceb03c19132886968.jpg' style='width: 80%'>
                        </div>
                        <div id='ccc__cc'
                            style='width: 30%; text-align: center; display: inline-block; position: relative; top: -20px !important; text-align: right'>
                            <h3>
                                <div id="date2"></div>
                            </h3>
                        </div>
                    </div>
                </header>
            <table  class="table table-stipred table-sm table-bordered">
                
                <thead style="background: #eee">
                    <th>
                        م
                    </th>
                    <th>
                        المعلم
                    </th>
                    <th>
                        نصاب الحصص
                    </th>
                    <th>
                         الدروس المعدة
                    </th>
                    <th>
                          الغير المعدة
                    </th>
                    <th>
                       إثراءات
                    </th>
                    <th>
                        واجبات
                    </th>
                    <th>
                        اختبارات
                    </th>
                    <th>
                        أنشطة
                    </th>
                    <th>
                        تهيئة
                    </th>
                    <th>
                        مفردات
                    </th>
                    <th>
                        استراتيجيات
                    </th>
                    <th>
                        الوسائل
                    </th>
                    <th>
                        مهارات
                    </th>
                    <th>
                        الاغلاق
                    </th>
                    <th>
                        التعليمات
                    </th>
                </thead>
                <tbody></tbody>
            </table>
            <footer class='dnone'>مدير المدرسة: {{ admin_name }}</footer>
        </div>
        <textarea class='get-local-storage' name="teachers" style='display: none'></textarea>
    </div>
  </div>
</template>

<script>
import { VBModal, BModal, BDropdown, BDropdownItem } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BDropdown,
    BDropdownItem,
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
    data(){
        return {
            arr: [],
            teachers: [],
            school_name: decodeURI(window.location.href.split("school_name=")[1].split("&")[0]),
            admin_name: decodeURI(window.location.href.split("admin_name=")[1].split("&")[0]),
        }
    },
    created(){
        var g = this;
        var v = setInterval(() => {
            if($(".get-local-storage-value[name='teachers']").length){
                if($(".get-local-storage[name='teachers-week']").length == 0){
                    $("body").append(`<textarea class='get-local-storage' name="teachers-week" style='display: none'></textarea>`)
                }
                if($(".get-local-storage-value[name='teachers-week']").length){
                clearInterval(v) 
                }else{
                    return
                }
            }else{
                return;
            }
            $("#fromto").html(decodeURIComponent(window.location.href.split("date=")[1].split("&s")[0]))
            g.teachers = JSON.parse($(".get-local-storage-value[name='teachers']").val())
            g.arr = JSON.parse($(".get-local-storage-value[name='teachers-week']").val())
            var r = {
                teachers: g.teachers,
                arr: g.arr
            }
            var i = 0;
            var t_ethrat = 0;
            var t_homeworks = 0;
            var t_exams = 0;
            var t_actives = 0;
            var t_notcreated = 0;
            var t_t = 0;
            var t_total = 0;
            var t_pre = 0, t_voc = 0, t_goals = 0, t_strat = 0, t_tools = 0, t_skills = 0,
            t_close = 0, t_notes = 0;
            r.teachers.forEach(teacher => {
                if (r.arr[teacher.id]) {
                    i++;
                    var ethrat = 0;
                    var homeworks = 0;
                    var exams = 0;
                    var notcreated = 0;
                    var actives = 0;
                    var pre = 0;
                    var voc = 0;
                    var goals = 0;
                    var strat = 0;
                    var tools = 0;
                    var skills = 0;
                    var close = 0;
                    var notes = 0;
                    var total = 0
                    t_t = t_t + r.arr[teacher.id]?.total_lessons
                    for (const [key, value] of Object.entries(r.arr[teacher.id]?.lessons)) {
                        if (value.ethrat > 0) {
                            ethrat = ethrat + 1
                            t_ethrat = t_ethrat + 1
                        }
                        if (value.homeworks > 0) {
                            homeworks = homeworks + 1
                            t_homeworks = t_homeworks + 1
                        }
                        if (value.exams > 0) {
                            exams = exams + 1
                            t_exams = t_exams + 1
                        }
                        if (value.actives > 0) {
                            actives = actives + 1
                            t_actives = t_actives + 1
                        }

                        if (value.pre > 0) {
                            pre = pre + 1
                            t_pre = t_pre + 1
                        }
                        if (value.voc > 0) {
                            voc = voc + 1
                            t_voc = t_voc + 1
                        }
                        if (value.goals > 0) {
                            goals = goals + 1
                            t_goals = t_goals + 1
                        }
                        if (value.strat > 0) {
                            strat = strat + 1
                            t_strat = t_strat + 1
                        }
                        if (value.tools > 0) {
                            tools = tools + 1
                            t_tools = t_tools + 1
                        }
                        if (value.skills > 0) {
                            skills = skills + 1
                            t_skills = t_skills + 1
                        }
                        if (value.close > 0) {
                            close = close + 1
                            t_close = t_close + 1
                        }
                        if (value.notes > 0) {
                            notes = notes + 1
                            t_notes = t_notes + 1
                        }

                        if (value.notcreated) {
                            notcreated = notcreated + 1;
                            t_notcreated = t_notcreated + 1;
                        } else {
                            total = total + 1
                            t_total = t_total + 1
                        }
                    }
                    $("tbody").append(`
                <tr>
                    <td>
                        ${i}
                    </td>
                    <td>
                        ${teacher.name}
                    </td>
                    <td>
                        ${r.arr[teacher.id]?.total_lessons}
                    </td>
                    <td>
                        ${total}
                    </td>
                    <td>
                        ${notcreated}
                    </td>
                    <td>
                        ${ethrat}
                    </td>
                    <td>
                        ${homeworks}
                    </td>
                    <td>
                        ${exams}
                    </td>
                    <td>
                        ${actives}
                    </td>
                    <td>
                        ${pre}
                    </td>
                    <td>
                        ${voc}
                    </td>
                    <td>
                        ${strat}
                    </td>
                    <td>
                        ${tools}
                    </td>
                    <td>
                        ${skills}
                    </td>
                    <td>
                        ${close}
                    </td>
                    <td>
                        ${notes}
                    </td>
                </tr>
                `)
                }
            });

            $("td:contains('%')").css("background", '#E8D2A6')
            $("td:contains('0%')").each(function () {
                if (new Number($(this).text().trim().replace('%', '')) == 0) {
                    $(this).css("background", '#F48484')
                }
            })
            $("td:contains('100%')").css("background", '#CDE990')

            function countItem(item, arr) {
                var r = 0
                arr.forEach(function (a) {
                    if (a[item]) {
                        r = r + (a[item] === true ? 1 : a[item]);
                    }
                })
                return r;
            }

            $("tbody").append(`
            <tr style='background:#ddd;'>
                <td style='border: none !important'>
                </td>
                <td>
                <strong>الأجمالي</strong>
                </td>
                <td>
                    ${t_t}
                </td>
                <td>
                    ${t_total}
                </td>
                <td>
                    ${t_notcreated}
                </td>
                <td>
                    ${t_ethrat}
                </td>
                <td>
                    ${t_homeworks}
                </td>
                <td>
                    ${t_exams}
                </td>
                <td>
                    ${t_actives}
                </td>
                <td>
                    ${t_pre}
                </td>
                <td>
                    ${t_voc}
                </td>
                <td>
                    ${t_strat}
                </td>
                <td>
                    ${t_tools}
                </td>
                <td>
                    ${t_skills}
                </td>
                <td>
                    ${t_close}
                </td>
                <td>
                    ${t_notes}
                </td>
            </tr>
            `)
        $("body").append(`
        <!-- The Modal -->
        <div id="myModal" class="modal">

        <!-- Modal content -->
        <div class="modal-content">
            <u><strong style='color: darkred; cursor: pointer' onclick="location.reload()">&times; اغلاق هذه النافذة</strong></u>
            <br><br>
            <div id='modal-content'></div>
        </div>

        </div>
        <style>
        body {font-family: Arial, Helvetica, sans-serif;}
        #modal-content table *{
            font-size: 20px;
            padding-right: 10px !important;
        }
        tr:nth-child(even) {
            background-color: #f2f2f2;
        }
        /* The Modal (background) */
        .modal {
        display: none; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        padding-top: 100px; /* Location of the box */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
        }

        /* Modal Content */
        .modal-content {
        background-color: #fefefe;
        margin: auto;
        padding: 20px;
        border: 1px solid #888;
        width: 60%;
        }

        /* The Close Button */
        .close {
        color: #aaaaaa;
        float: right;
        font-weight: bold;
        }

        .close:hover,
        .close:focus {
        color: #000;
        cursor: pointer;
        }
        </style>
        `)
        }, 100);
        setTimeout(() => {
            var isNumeric = function(num){
                return (typeof(num) === 'number' || typeof(num) === "string" && num.trim() !== '') && !isNaN(num);  
            }
            $("tr td").each(function(){
                if(isNumeric($(this).text()) && $(this).index() != 0){
                    var total = new Number($(this).parent().find("td:nth-child(3)").text());
                    if(new Number($(this).text()) == 0){
                        $(this).css('background-color', '#FFB0B0')
                    }else if(new Number($(this).text()) < total){
                        $(this).css('background-color', '#FFE6A5')
                    }
                }
            })
        }, 1000);
    },
    methods: {

        printDiv() {
            document.getElementById("date2").innerHTML = document.getElementById("ffff").innerHTML
            var divToPrint=document.getElementById("headerTable");
            var newWin= window.open("");
            newWin.document.write(divToPrint.outerHTML + `<style>
            #headerTable{
                  position: relative;
            top: -100px;
            width: 100%;
            margin: 0px auto;
            }
                body{
                    direction: rtl;
                    text-align: right
                }
                thead{
                    background: #eee;
                }
                table, td, th {
                border: 1px solid;
                white-space: nowrap;
                text-align: center
                }
                tr:nth-child(even) {
                    background-color: #f2f2f2;
                }
                table {
                width: 100%;
                border-collapse: collapse;
                }
                button{
                    display:none
                }
                @page {
                    margin: 0;
                }
                </style>`);
            newWin.document.close();
            newWin.print();
        },
        exportToExcel() {
            var location = 'data:application/vnd.ms-excel;base64,';
            var excelTemplate = '<html> ' +
                '<head> ' +
                '<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/> ' +
                '</head> ' +
                '<body> ' +
                document.getElementById("headerTable").outerHTML +
                '</body> ' +
                '</html>';
                excelTemplate = excelTemplate.replaceAll("<img", "<br style='display:none'")
            window.location.href = location + btoa(unescape(encodeURIComponent((excelTemplate))));
            setTimeout(() => {
                window.location = window.location.href
            }, 1000);
        },
    }
}
</script>

<style>
#date2{
    display: none;
}
th,td{
    text-align: center;
}
</style>